
class CapDeleteAnyPendingNotifications {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'delete_any_pending_notifications'
}

function create(config) {
  return new CapDeleteAnyPendingNotifications(config)
}

export default {
  key,
  create,
}
